// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IAccountTypeAggregationDto
 */
export interface IAccountTypeAggregationDto {
    /**
     * 
     * @type {string}
     * @memberof IAccountTypeAggregationDto
     */
    account_type?: IAccountTypeAggregationDtoAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IAccountTypeAggregationDto
     */
    account_description?: string;
    /**
     * 
     * @type {number}
     * @memberof IAccountTypeAggregationDto
     */
    employees_count?: number;
}

/**
* @export
* @enum {string}
*/
export enum IAccountTypeAggregationDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IAccountTypeAggregationDto interface.
 */
export function instanceOfIAccountTypeAggregationDto(value: object): value is IAccountTypeAggregationDto {
    return true;
}

export function IAccountTypeAggregationDtoFromJSON(json: any): IAccountTypeAggregationDto {
    return IAccountTypeAggregationDtoFromJSONTyped(json, false);
}

export function IAccountTypeAggregationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountTypeAggregationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
        'account_description': json['account_description'] == null ? undefined : json['account_description'],
        'employees_count': json['employees_count'] == null ? undefined : json['employees_count'],
    };
}

export function IAccountTypeAggregationDtoToJSON(json: any): IAccountTypeAggregationDto {
    return IAccountTypeAggregationDtoToJSONTyped(json, false);
}

export function IAccountTypeAggregationDtoToJSONTyped(value?: IAccountTypeAggregationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'account_type': value['account_type'],
        'account_description': value['account_description'],
        'employees_count': value['employees_count'],
    };
}

